import { Mediator } from '@studio/design-system/input';
import { toPort } from '@studio/models/net';
import { useLatestFn } from '@studio/react-utils/hooks';
import { forwardRef, useMemo } from 'react';
import type { SyntheticEvent } from 'react';
import type { Props } from './types.js';
import { StudioError } from '#~/error/index.js';

/** `<Port>` component. */
export const Port = forwardRef<HTMLInputElement, Props>(({ port, ...props }, forwardedRef) => {
  const currentPort = useMemo(
    () =>
      toPort(port.value) ??
      ((): never => {
        throw new StudioError('Invalid port');
      })(),
    [port.value]
  );

  const handleCommit = useLatestFn((nextValue: string, event: SyntheticEvent) => {
    const nextPort = toPort(nextValue);

    // Is this a valid port and has it changed?
    if (nextPort && nextPort !== currentPort) {
      port(nextPort);
    } else {
      event.preventDefault();
    }
  });

  return <Mediator onCommit={handleCommit} ref={forwardedRef} value={currentPort} {...props} />;
});
